import { useMemo } from 'react'

import { Offer } from '@wwt/entities/search-response'
import { extractFeaturesFromOffer } from '@wwt/shared/utils'

export const useOfferCardFeatures = (offer: Offer) => {
	return useMemo(() => extractFeaturesFromOffer(offer, 6), [offer])
}
